<template>
  <span
    :class="rootClasses"
    class="flex-shrink-0 inline-flex items-center px-2 py-1 rounded-full"
  >
    <AppTypography size="text-xs" weight="font-medium" leading="leading-none">
      <slot>
        {{ props.text }}
      </slot>
    </AppTypography>
  </span>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import AppTypography from './AppTypography.vue'

const props = withDefaults(
  defineProps<{
    text?: string
    variant?:
      | 'fill-blue'
      | 'fill-blue-faded'
      | 'fill-red'
      | 'fill-red-faded'
      | 'fill-green'
      | 'fill-green-faded'
      | 'fill-gray'
      | 'fill-gray-faded'
      | 'fill-orange'
      | 'fill-orange-faded'
      | 'fill-gray-faded'
      | 'outline-blue'
      | 'outline-blue-faded'
      | 'outline-red'
      | 'outline-red-faded'
      | 'outline-green'
      | 'outline-green-faded'
      | 'outline-gray'
      | 'outline-gray-faded'
  }>(),
  {
    variant: 'fill-blue',
  },
)

const rootClasses = computed(() => {
  return [
    ...{
      'fill-blue': ['text-white bg-blue-600'],
      'fill-blue-faded': ['text-blue-800 bg-blue-100'],
      'fill-red': ['text-white bg-red-600'],
      'fill-red-faded': ['text-red-800 bg-red-100'],
      'fill-green': ['text-white bg-green-600'],
      'fill-green-faded': ['text-green-800 bg-green-200'],
      'fill-gray': ['text-white bg-gray-600'],
      'fill-gray-faded': ['text-gray-800 bg-gray-200'],
      'fill-orange': ['text-white bg-orange-600'],
      'fill-orange-faded': ['text-orange-800 bg-orange-100'],
      'outline-blue': ['text-blue-600 bg-white border border-blue-600'],
      'outline-blue-faded': ['text-blue-600 bg-white border border-gray-300'],
      'outline-red': ['text-red-800 bg-white border border-red-600'],
      'outline-red-faded': ['text-red-800 bg-white border border-red-100'],
      'outline-green': ['text-green-600 bg-white border border-green-600'],
      'outline-green-faded': [
        'text-green-800 bg-white border border-green-100',
      ],
      'outline-gray': ['text-gray-600 bg-white border border-gray-600'],
      'outline-gray-faded': ['text-gray-800 bg-white border border-gray-100'],
    }[props.variant],
  ]
})
</script>
